import commonChartTemplate from './views/commonChart.html';
import commonChartCtrl from './controllers/commonChartController';

export default angular.module('commonChart', [])
    .component('commonChart', {
        template: commonChartTemplate,
        transclude: true,
        bindings: {
            graphData: '<',
            showGraph: '<',
            graphWidth: '<',
            graphHeight: '<',
            chartType: '<',
            title: '<',
            subTitle: '<',
            axis: '<',
            header: '<',
            totalCount: '<',
            count: '<',
            colors: '<',
            names: '<',
            setLocalImage: '&setimage'
        },
        scope: {
            setLocalImage: '&setimage'
        },
        controller: commonChartCtrl
    })
    .constant('COMMON_CHART_CONSTANTS', {
        DEFAULT_GRAPH_COLORS: ['#3366CC', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#329262', '#5574A6', '#3B3EAC']
    });



// WEBPACK FOOTER //
// ./src/app/common-chart/commonChartModule.js